import Svg, { SvgProps } from './Svg';

export default function DoubleUpIcon({
  color = 'currentColor',
  ...props
}: SvgProps) {
  return (
    <Svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <path d="M4 6L7 3M7 3L10 6M7 3V17M14 6L17 3M17 3L20 6M17 3V17M4 21H20" />
    </Svg>
  );
}
